export enum SegDeleteMergeResult {
  Deleted = 'deleted',
  Merged = 'merged',
}
